<template>
  <div class="homepage-key-statistics-additional-blocks__wrapper">
    <homepage-key-statistics-additional-block
      v-for="item in items"
      :key="item.title"
      :item="item"
    />
  </div>
</template>

<script>
import { ICON } from 'shared/AIcon/index.vue'
import HomepageKeyStatisticsAdditionalBlock from '@/components/_sections/_homepage/HomepageKeyStatistics/HomepageKeyStatisticsAdditionalBlocks/HomepageKeyStatisticsAdditionalBlock/index.vue'

export default {
  name: 'HomepageKeyStatisticsAdditionalBlocks',
  components: {
    HomepageKeyStatisticsAdditionalBlock
  },
  data() {
    return {
      items: [
        {
          title: 'User Retention',
          percentage: 25,
          description: 'increase in daily active users.',
          icon: ICON.USER_RETENTION_PERCENTAGE,
          iconHeight: 132,
          footerText: 'ForexLive Internal Analytics'
        },
        {
          title: 'Trading Volume',
          percentage: 18,
          description: 'average increase.',
          icon: ICON.TRADING_VOLUME_PERCENTAGE,
          iconHeight: 121,
          footerText: 'Finance Magnates Intelligence data'
        },
        {
          title: 'User Engagement',
          percentage: 30,
          description: 'increase in session duration',
          icon: ICON.USER_ENGAGEMENT_PERCENTAGE,
          iconHeight: 149,
          footerText: 'ForexLive engagement report'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.homepage-key-statistics-additional-blocks__wrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  $margin: (
    $above-desktop-xl: 0 -32px,
    $desktop-lg: 0 -40px,
    $tablet: 32px 0 0,
    $mobile: 8px 0 0
  );

  @include setStyleByBreakpoint('margin', $margin);

  @include tablet {
    flex-direction: column;
    align-items: center;
  }
}
</style>
